import { render, staticRenderFns } from "./table-tr.vue?vue&type=template&id=550b1de4&"
import script from "./table-tr.vue?vue&type=script&lang=js&"
export * from "./table-tr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangbin/workspace/project/bin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('550b1de4')) {
      api.createRecord('550b1de4', component.options)
    } else {
      api.reload('550b1de4', component.options)
    }
    module.hot.accept("./table-tr.vue?vue&type=template&id=550b1de4&", function () {
      api.rerender('550b1de4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/table/table-tr.vue"
export default component.exports